// _ordenSchema.js — normalización del doble esquema de la colección `ordenes`.
//
// `ordenes` tiene documentos de dos orígenes: los que escribe la app (esquema
// camelCase: estado, fechaProgramada, totalAmount, tecnicoNombre…) y los que
// sincroniza syncDeltaStelOrder en crudo (kebab-case: document-state-id,
// date, total-amount, assignee-id…). Cualquier vista que lea `ordenes` y solo
// entienda uno de los dos esquemas "ve" únicamente una parte de las órdenes
// — justo lo que le pasaba a Informes (solo reflejaba las cerradas desde la
// app). Este módulo lo unifica en un solo sitio.

export const STEL_STATE_MAP = {
  651457:  'pendiente',
  651428:  'cerrada',
  1018827: 'en_ruta',
  1016222: 'pendiente_material',
  1016221: 'pendiente_sustitucion',
  1007173: 'pendiente_pago',
  1016219: 'cobrada',
  1004686: 'garantia',
  1016220: 'ausente',
  1040205: 'pendiente_presupuesto',
  1305009: 'instalacion',
  1041994: 'garantia_ariston',
  1069646: 'garantia_nofer',
  1069647: 'garantia_svan',
  1070405: 'garantia_logman',
  1226452: 'garantia_beretta',
};

export const TECNICO_ID_NOMBRE = {
  21936: 'Benito', 23415: 'Pablo', 21945: 'Dani', 31171: 'Ivan', 25901: 'Joaquin',
};

const soloFecha = v => (v ? String(v).slice(0, 10) : null);

// Devuelve la orden con los campos que usan las vistas resueltos desde
// cualquiera de los dos esquemas. Los docs que ya traen `estado` (esquema
// app) se completan igualmente por si les falta algún campo, sin pisar los
// que sí tienen.
export function normalizeOrden(o) {
  const tecnicoId = o.tecnicoId ?? o['assignee-id'] ?? o['agent-id'] ?? null;
  const estado = o.estado || STEL_STATE_MAP[o['document-state-id']] || null;
  return {
    ...o,
    estado,
    referencia:      o.referencia || o['full-reference'] || o.reference || (o.id ? `#${o.id}` : ''),
    fechaProgramada: o.fechaProgramada || soloFecha(o.date) || null,
    fechaCierre:     o.fechaCierre || soloFecha(o['closing-date'])
                     || (['cobrada', 'cobrada_sin_firma', 'pendiente_pago', 'cerrada'].includes(estado)
                         ? soloFecha(o['utc-last-modification-date']) : null),
    totalAmount:     Number(o.totalAmount ?? o['total-amount'] ?? 0) || 0,
    tecnicoId,
    tecnicoNombre:   o.tecnicoNombre || o['assignee-name']
                     || (tecnicoId != null ? (TECNICO_ID_NOMBRE[Number(tecnicoId)] || null) : null)
                     || 'Sin asignar',
    clienteNombre:   o.clienteNombre || o['customer-name'] || o.clientName || '',
    tipo:            o.tipo || o['work-order-type']?.name || null,
    prioridad:       o.prioridad || o.priority || null,
  };
}
